export const THEME_STORAGE_KEY = "theme";

// Inlined in each app's index.html <head> so the right class is on <html>
// before first paint; ThemeProvider takes over after hydration. Written as
// oxfmt prints it at <head>-child depth, so a pasted copy stays byte-identical
// under the formatter and the CSP hash of its body holds.
export const THEME_BOOT_SCRIPT = `<script>
      try {
        var t = localStorage.getItem("${THEME_STORAGE_KEY}"),
          d =
            t === "dark" ||
            ((!t || t === "system") &&
              matchMedia("(prefers-color-scheme: dark)").matches);
        document.documentElement.classList.add(d ? "dark" : "light");
      } catch (e) {}
    </script>`;

// The CSP source for the script body above; theme-boot.test.ts recomputes it.
export const THEME_BOOT_SCRIPT_SHA256 =
  "sha256-Qq7Uqb4BDYI5HkSNCxqnoCPGNLnmia5dYX6CbwETH6Q=";
